import API from 'API';

export const validateUniqueUnits = async (name, id) => {
  if (!name) {
    return 'Units is required';
  } else if (await API.find(`metricUnits/validateUniqueName`, {name, id})) {
    return 'Units already exists';
  } else {
    return '';
  }
};

export const validateUniqueConsumableName = async (name, id) => {
  if (!name) {
    return 'Name is required';
  } else if (await API.find(`consumables/validateUniqueName`, {name, id})) {
    return 'Name already exists';
  } else {
    return '';
  }
};

export const validateUniqueConsumableProductCode = async (productCode, id) => {
  if (!productCode) {
    return 'Product code is required';
  } else if (
    await API.find(`consumables/validateUniqueProductCode`, {productCode, id})
  ) {
    return 'Product code already exists';
  } else {
    return '';
  }
};

export const saveConsumable = async (consumable) =>
  API.save(`consumables/`, consumable);

export const saveMetricUnit = async (consumableUnit) =>
  API.save(`metricUnits/`, consumableUnit);

export const findConsumables = async () => API.find('consumables/');

export const findMetricUnits = async () => API.find('metricUnits/');

export const findConsumable = async (id) => API.find(`consumables/${id}`);

export const findMetricUnit = async (id) => API.find(`metricUnits/${id}`);
